import React from "react";
import { connect } from "react-redux";
import * as emailsActions from "../../../store/admin";
import { bindActionCreators } from "redux";
import { GridLoader } from "react-spinners";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { css } from "@emotion/core";
import { config } from "../../../config/config";
import "react-notifications/lib/notifications.css";
import { deviceDetect } from "react-device-detect";
import { utilService } from "../../../common/utils";

const override = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

/**
 * This componet is used to send emails such as weekly, daily and principal emails
 */

class Email extends React.Component {
  constructor(props) {
    super(props);
    // bind input events
    this.onSaveBlurb = this.onSaveBlurb.bind(this);
    // init state
    this.state = {
      weekly_email_text_data: {},
      email_data: {
        type: "Weekly",
        recipient: "vvasani@plc.nsw.edu.au",
        email_testing: true,
        except_emails_list: [],
      },
      errors: {},
      isLoading: false,
      isBlurbSaving: false,
      sendingEmails: false,
      isSaveListSaving: false,
      isSaveTestAddress: false,
    };
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "email",
      title: "Email",
      browserName: browserName,
      osName: osName,
      pageType: "Email Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });

    // fetch blurb for weekly digest
    this.props.getEmailText({
      token: this.props.token,
    });
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs.
   * @param {*} prevProps Getting previous props
   * @param {*} prevState Getting previous state
   */
  componentDidUpdate(prevProps, prevState) {
    // update state values when props update
    if (
      prevProps.sendEmailsActionLoading &&
      !this.props.sendEmailsActionLoading
    ) {
      if (prevProps.error !== this.props.error) {
        if (this.props.error) {
          NotificationManager.error(this.props.error);
        }
      }
      if (prevState.sendingEmails) {
        this.setState(
          {
            errors: {},
            isLoading: false,
            sendingEmails: false,
          },
          function () {
            if (this.props.sent_users.length === 0) {
              NotificationManager.success(
                "Success",
                "No any user was in queue"
              );
            }
            // NotificationManager.success('Success message', 'Saved successfully.');
          }
        );
      }
      if (
        prevProps.sent_users !== this.props.sent_users &&
        this.props.sent_users.length > 0
      ) {
        NotificationManager.success(
          "Success",
          "Emails sent successfully",
          86400000
        );
      }
      if (prevState.isBlurbSaving) {
        this.setState(
          {
            errors: {},
            isLoading: false,
            isBlurbSaving: false,
          },
          function () {
            NotificationManager.success(
              "Success message",
              "Saved successfully."
            );
          }
        );
      }
      if (prevState.isSaveListSaving) {
        this.setState(
          {
            errors: {},
            isLoading: false,
            isSaveListSaving: false,
          },
          function () {
            NotificationManager.success(
              "Success message",
              "List Saved successfully."
            );
          }
        );
      }
      if (prevState.isSaveTestAddress) {
        this.setState(
          {
            errors: {},
            isLoading: false,
            isSaveTestAddress: false,
          },
          function () {
            NotificationManager.success(
              "Success message",
              "Test address saved successfully"
            );
          }
        );
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // set weekly email text when props change
    if (
      nextProps.weeklyEmailText !== this.props.weeklyEmailText &&
      nextProps.weeklyEmailText.length > 0
    ) {
      this.setState({
        weekly_email_text_data: nextProps.weeklyEmailText[0],
        email_data: {
          ...this.state.email_data,
          except_emails_list: nextProps.weeklyEmailText[0].except_emails_list,
        },
      });
    }
  }

  /**
   * Function used for handle input change event
   * @param {*} e Input Event
   * @param {*} dict state dictionary
   */
  handleInputChange(dict, e) {
    const { name, value } = e.target;
    // update state value on change input
    let fields = this.state[dict];
    // for radio input event
    if (name === "email_testing") {
      fields[name] = value === "true" ? true : false;
    } else {
      fields[name] = value;
    }
    this.setState({
      fields,
    });
  }

  /**
   * Validate form before submit data
   */
  validateForm() {
    let fields = this.state.weekly_email_text_data;
    let errors = {};
    let formIsValid = true;

    if (!fields["email_text"]) {
      formIsValid = false;
      errors["email_text"] = "*Please enter blurb.";
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  /**
   * Save blurb text
   * @param {*} e Submit Event
   */
  onSaveBlurb(e) {
    console.log(this.state);
    // validate form befor submit
    if (this.validateForm()) {
      let fields = this.state.weekly_email_text_data;
      // update blurb text if weekly text already exist
      if (this.state.weekly_email_text_data.weeklyemailtextUid) {
        fields["updated_at"] = new Date();
        this.setState({
          fields,
          isLoading: true,
          isBlurbSaving: true,
        });
        // dispatch action to update weekly email text
        this.props.updateEmailText({
          token: this.props.token,
          data: this.state.weekly_email_text_data,
        });
      } else {
        // save new blurb text
        fields["created_at"] = new Date();
        fields["updated_at"] = new Date();
        fields["users_userid"] = this.props.user.userUid;
        fields["users_username"] = this.props.user.username;
        fields["users_firstname"] = this.props.user.firstname;
        fields["users_lastname"] = this.props.user.surname;

        // update state values
        this.setState({
          fields,
          isLoading: true,
          isBlurbSaving: true,
        });
        // dipatch action to save blurb
        this.props.saveEmailText({
          token: this.props.token,
          data: this.state.weekly_email_text_data,
        });
      }
    }
  }

  /**
   * Save test address into databse
   */
  onSaveTestAddress() {
    // validate test email address
    let fields = this.state.email_data;
    let errors = {};
    let formIsValid = true;
    if (!fields["test_email"]) {
      formIsValid = false;
      errors["test_email"] = "*Please enter email id.";
    } else {
      let emailId = fields["test_email"].trim();
      if (utilService.validateEmail(emailId)) {
        formIsValid = true;
      } else {
        formIsValid = false;
        errors["test_email"] = "*Please enter valid email id.";
      }
    }
    if (formIsValid) {
      // update emaild id
      if (this.state.weekly_email_text_data.weeklyemailtextUid) {
        let testEmailsField = this.state.weekly_email_text_data;
        testEmailsField["test_emails_list"].push(fields["test_email"]);
        testEmailsField["updated_at"] = new Date();
        this.setState(
          {
            testEmailsField,
            isSaveTestAddress: true,
          },
          function () {
            // dispatch action to update test emails
            this.props.updateEmailText({
              token: this.props.token,
              data: this.state.weekly_email_text_data,
            });
          }
        );
      }
    } else {
      this.setState({
        fields,
        errors: errors,
      });
    }
  }

  /**
   * Send weekly/principal/daily emails
   * @param {*} e Submit event
   */
  sendEmails(e) {
    console.log(this.state.email_data);
    let fields = this.state.email_data;

    var email_data = {};
    email_data["type"] = this.state.email_data.type;
    if (this.state.email_data.email_testing) {
      email_data["recipient"] = this.state.email_data["recipient"];
      email_data["email_testing"] = true;
    }
    if (this.state.email_data["except_emails_list"]) {
      email_data["except_for"] = this.state.email_data["except_emails_list"];
    }
    fields["except_for_emails"] = "";

    this.setState(
      {
        fields,
        isLoading: true,
        sendingEmails: true,
      },
      function () {
        console.log(email_data);
        this.props.sendEmails({
          token: this.props.token,
          data: email_data,
        });
      }
    );
  }

  /**
   * Save except emails into database
   * @param {*} e
   */
  onSaveList(e) {
    // validate emails before save into database
    let fields = this.state.weekly_email_text_data;
    let errors = {};
    let formIsValid = true;
    let trim_emails = [];
    if (!fields["except_emails"]) {
      formIsValid = false;
      errors["except_emails"] = "*Please enter email ids.";
    } else {
      let except_emails = fields["except_emails"];
      fields["except_emails"] = fields["except_emails"].replace(/\r?\n/g, ",");
      fields["except_emails"] = fields["except_emails"].trim();
      fields["except_emails"] = fields["except_emails"].split(",");

      fields["except_emails"].forEach((item, index) => {
        item = item.trim();
        if (item) {
          if (utilService.validateEmail(item)) {
            trim_emails.push(item);
          } else {
            formIsValid = false;
            errors["except_emails"] = "*Please select valid email ids.";
          }
        }
      });
      if (formIsValid) {
        fields["except_emails"] = except_emails;
        // fields["except_emails_emails"] = trim_emails.join();
      } else {
        fields["except_emails"] = except_emails;
      }
    }

    if (formIsValid) {
      console.log(this.state.weekly_email_text_data);
      let saveListData = {};
      let exceptEmailsList = trim_emails.join();
      exceptEmailsList = exceptEmailsList.split(",");
      // update except emails if already exist
      if (this.state.weekly_email_text_data.weeklyemailtextUid) {
        saveListData = this.state.weekly_email_text_data;
        saveListData["except_emails"] = fields["except_emails"];
        saveListData["except_emails_list"] = exceptEmailsList;
        saveListData["updated_at"] = new Date();
        this.setState({
          fields,
          errors: {},
          isLoading: true,
          isSaveListSaving: true,
        });
        console.log(saveListData);
        // dispatch action to update except emails
        this.props.updateEmailText({
          token: this.props.token,
          data: saveListData,
        });
      } else {
        // save new except emails
        saveListData["except_emails"] = fields["except_emails"];
        saveListData["except_emails_list"] = exceptEmailsList;
        saveListData["created_at"] = new Date();
        saveListData["updated_at"] = new Date();
        saveListData["users_userid"] = this.props.user.userUid;
        saveListData["users_username"] = this.props.user.username;
        saveListData["users_firstname"] = this.props.user.firstname;
        saveListData["users_lastname"] = this.props.user.surname;

        // update state values
        this.setState({
          fields,
          errors: {},
          isLoading: true,
          isSaveListSaving: true,
        });
        // dipatch action to save except emails
        this.props.saveEmailText({
          token: this.props.token,
          data: saveListData,
        });
      }
    } else {
      this.setState({
        fields,
        errors: errors,
      });
    }
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */

  render() {
    console.log(this.state);
    return (
      <div>
        <div className="email-type d-flex justify-content-around">
          <label className="typeradio mb-0">
            Weekly Digest
            <input
              type="radio"
              name="type"
              checked={this.state.email_data.type === "Weekly"}
              value="Weekly"
              onChange={this.handleInputChange.bind(this, "email_data")}
            />
            <span className="radiomark"></span>
          </label>
          <label className="typeradio mb-0">
            Daily Reminders
            <input
              type="radio"
              name="type"
              checked={this.state.email_data.type === "Daily"}
              value="Daily"
              onChange={this.handleInputChange.bind(this, "email_data")}
            />
            <span className="radiomark"></span>
          </label>
          <label className="typeradio mb-0">
            Principals Message
            <input
              type="radio"
              name="type"
              checked={this.state.email_data.type === "Principal"}
              value="Principal"
              onChange={this.handleInputChange.bind(this, "email_data")}
            />
            <span className="radiomark"></span>
          </label>
        </div>
        {this.props.sendEmailsActionLoading === true && (
          <div className="sweet-loading">
            <GridLoader
              css={override}
              sizeUnit={"px"}
              size={40}
              color={"#cadb2a"}
              loading={this.props.sendEmailsActionLoading}
            />
          </div>
        )}
        {this.state.email_data.type === "Weekly" && (
          <div className="blurb pt-3">
            <label className="d-block">Blurb for Weekly Digest</label>
            <textarea
              name="email_text"
              cols="30"
              rows="10"
              className="w-100"
              onChange={this.handleInputChange.bind(
                this,
                "weekly_email_text_data"
              )}
              value={this.state.weekly_email_text_data.email_text || ""}
            ></textarea>
            <div className="errorMsg">{this.state.errors["email_text"]}</div>
            <div className="row justify-content-between">
              <div className="wrap col-md-8">
                <pre>{`LINK: <A HREF="https://places.plc.sydney" style="color:#C41425">CLICK HERE</A>`}</pre>
                <pre>{`BOLD: This text is <B>bold</B>`}</pre>
                <pre>{`NEWLINE: <br />`}</pre>
                {/* <xmp className="m-0 break-space" style="color: #58ac98">LINK: <A HREF="http://www.plc.nsw.edu.au" style="color:#C41425">CLICK HERE</A></xmp> */}
                {/* <xmp className="m-0 break-space" style="color: #58ac98">BOLD: This text is <B>bold</B><br /></xmp>
              <xmp className="m-0 break-space" style="color: #58ac98">NEWLINE: <br /></xmp> */}
              </div>
              <div className="text-right col-md-4">
                <button
                  className="live"
                  onClick={this.onSaveBlurb}
                  disabled={this.state.isBlurbSaving}
                >
                  {this.state.isBlurbSaving ? "Save Blurb..." : "Save Blurb"}
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="blurb pt-3">
          <label className="d-block">
            Don't send emails to people in this list
          </label>
          <textarea
            name="except_emails"
            id=""
            cols="30"
            rows="5"
            onChange={this.handleInputChange.bind(
              this,
              "weekly_email_text_data"
            )}
            className="w-100"
            value={this.state.weekly_email_text_data.except_emails || ""}
          ></textarea>
          <div className="errorMsg">{this.state.errors["except_emails"]}</div>
          <div className="text-right">
            <button
              className="live"
              disabled={this.state.isSaveListSaving}
              onClick={this.onSaveList.bind(this)}
            >
              {this.state.isSaveListSaving ? "Save List..." : "Save List"}
            </button>
          </div>
        </div>
        <h3>Testing Controls</h3>
        <div className="testing-control">
          <div className="d-flex pb-5">
            <label className="typeradio mb-0">
              Testing Off
              <input
                type="radio"
                name="email_testing"
                checked={this.state.email_data.email_testing === false}
                onChange={this.handleInputChange.bind(this, "email_data")}
                value="false"
              />
              <span className="radiomark"></span>
            </label>
            <label className="typeradio mb-0 ml-5">
              Testing On
              <input
                type="radio"
                name="email_testing"
                checked={this.state.email_data.email_testing === true}
                onChange={this.handleInputChange.bind(this, "email_data")}
                value="true"
              />
              <span className="radiomark"></span>
            </label>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="recepient pb-5">
                <label className="d-flex flex-column">
                  <strong>Override ALL recipients with this address</strong>
                  <select
                    className="form-control"
                    name="recipient"
                    onChange={this.handleInputChange.bind(this, "email_data")}
                    value={this.state.email_data.recipient || ""}
                  >
                    <option value="">Select recipient</option>
                    {this.state.weekly_email_text_data.test_emails_list &&
                      this.state.weekly_email_text_data.test_emails_list.map(
                        (item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        )
                      )}
                  </select>
                </label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="recepient pb-5">
                <label className="d-flex flex-column">
                  <strong>Add this address to test account</strong>
                  <input
                    type="text"
                    className="emailText"
                    name="test_email"
                    onChange={this.handleInputChange.bind(this, "email_data")}
                  />
                  <div className="errorMsg">
                    {this.state.errors["test_email"]}
                  </div>
                </label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="blurb mt-2 recepient">
                <button
                  className="saveEmail"
                  onClick={this.onSaveTestAddress.bind(this)}
                  disabled={this.state.isSaveTestAddress}
                >
                  {this.state.isSaveTestAddress
                    ? "Save Address..."
                    : "Save Address"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <button
          className="btn-blue w-100 mt-2"
          onClick={this.sendEmails.bind(this)}
          disabled={this.state.sendingEmails}
        >
          {this.state.sendingEmails ? "Send Emails..." : "Send Emails"}
        </button>
        <div className="overlay"></div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  console.log(state);
  return {
    sendEmailsActionLoading: state.sendEmails.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    error: state.sendEmails.error,
    sent_users: Object.values(state.sendEmails.byId),
    weeklyEmailText: Object.values(state.sendEmails.weeklyDigest.byId),
  };
}
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(emailsActions, dispatch)
)(Email);
